import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import canvasReducer from './slices/canvasSlice';
import groupReducer from './slices/groupSlice';
import adminReducer from './slices/adminSlice';
import accountReducer from './slices/accountSlice'
import userDashboardReducer from './slices/userDashboardSlice';
import incomeReducer from './slices/incomeSlice';
import budgetReducer from './slices/budgetSlice';
import externalSubscriptionReducer from './slices/externalSubscriptionSlice';
import savingReducer from './slices/savingSlice'
import debtReducer from './slices/debtSlice';
import mortgageReducer from './slices/mortgageSlice';
import investmentReducer from './slices/investmentSlice';
import historyReducer from './slices/historySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user:userReducer,
    subscription:subscriptionReducer,
    canvas:canvasReducer,
    group: groupReducer,
    admin:adminReducer,
    account: accountReducer,
    userDashboard:userDashboardReducer,
    income: incomeReducer,
    budget:budgetReducer,
    externalSubscriptions: externalSubscriptionReducer,
    saving:savingReducer,
    debt: debtReducer,
    mortgage: mortgageReducer,
    investment:investmentReducer,
    history:historyReducer,
  },
});